// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"3c774b28","64":"0914fd6a","262":"e1970f67","309":"0b2c473b","507":"096025ae"}[chunkId] + ".chunk.css";
};